import { defineStore } from 'pinia'

export const useNavigationHistoryStore = defineStore('navigationHistory', {
  state: () => ({
    lastUrl: '/',
  }),
  actions: {
    async updateLastUrl (url) {
        this.lastUrl = url
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'navigation-history-store',
        storage: localStorage,
      },
    ],
  }
})
